/**
 * Expects a `never` value. Strictly for type-checking, does not throw.
 */
export function shouldBeNever(_value: never) {}
